import clsx from 'clsx'
import { JSX } from 'react'
import { Stack } from '~/components-v2'
import QuoteMarkClose from '~/components/illustration/embed/quote-close.svg?react'
import QuoteMarkOpen from '~/components/illustration/embed/quote-open.svg?react'

type CompareQuoteProps = {
  type: 'positive' | 'warn'
  quote: JSX.Element
  caseStudyLink?: JSX.Element
  linkURL?: string
  linkLabel?: string
  details?: JSX.Element
  linkType?: 'case-study' | 'default'
  isQuote?: boolean
}

export const CompareQuote = ({
  type,
  quote,
  caseStudyLink,
  linkURL,
  linkLabel,
  linkType = 'default',
  details,
  isQuote = true,
}: CompareQuoteProps) => {
  return (
    <div className="compare-item">
      <Stack className={clsx('compare-quote', `quote-type-${type}`)} gap={4}>
        {isQuote && <QuoteMarkOpen />}
        {quote}
        {isQuote && linkLabel && linkURL ? (
          <>
            {linkType === 'default' ? (
              <span>
                –{' '}
                <a href={linkURL} target="_blank" rel="noreferrer">
                  {linkLabel}
                </a>
              </span>
            ) : (
              <span>
                – {linkLabel}{' '}
                {caseStudyLink ? (
                  caseStudyLink
                ) : (
                  <>
                    (
                    <a href={linkURL} target="_blank" rel="noreferrer">
                      read the case study
                    </a>
                    )
                  </>
                )}
              </span>
            )}
          </>
        ) : null}

        {details && <div className="compare-quote-details">{details}</div>}
        {isQuote && <QuoteMarkClose />}
      </Stack>
    </div>
  )
}
